<template>
  <div id="memberCenter">
    <div class="bg">
      <el-row v-loading="loading">
        <el-col :span="18" :offset="3">
          <el-tabs v-model="activeIndex" tab-position="left" style="min-height:400px">
            <el-tab-pane name="userInfo" label="用户信息">
              <div class='wrap-box'>
                <el-row :gutter="40" class="space">
                  <el-col :span="12">
                    <el-divider content-position="left">登录邮箱号（不可修改）</el-divider>
                    <el-input v-model="user.user_email" :disabled="true" placeholder="用户邮箱"></el-input>                    
                  </el-col>
                  <el-col  :span="12">
                    <div>
                      <el-divider content-position="left">账号类型</el-divider>
                      <el-radio v-model="user.iscompanyhr" label="企业HR" border size="small">企业HR</el-radio>
                      <el-radio v-model="user.iscompanyhr" label="供应商账号" border size="small">服务商账号</el-radio>
                    </div>                    
                  </el-col>
                </el-row>
                <el-row :gutter="40" class="space">
                  <el-col  :span="12">
                    <el-divider content-position="left">公司名全称</el-divider>
                    <el-input v-model="user.companyname" placeholder="用户公司名"></el-input>                    
                  </el-col>
                  <el-col  :span="12">
                    <el-divider content-position="left">用户所属行业名</el-divider>
                    <el-input v-model="user.hangye" placeholder="用户行业"></el-input>                    
                  </el-col>                  
                </el-row>
                <el-row :gutter="40" class="space" type="flex" align="bottom">
                  <el-col :span="12">
                    <el-divider content-position="left">用户职位名</el-divider>
                    <el-input v-model="user.post" placeholder="用户职位"></el-input>
                  </el-col>
                  <el-col :span="12">
                    <!-- <span>专属邀请码：{{ user.id }}</span> -->                    
                    <el-button type="primary" style="width:100%" @click="submit">提交</el-button>
                  </el-col>
                </el-row>
                <!-- <el-row :gutter="40" class="space" type="flex" align="bottom">
                  <el-col :span="24">
                    <span>推广链接：http://www.taizhicn.com/#/registe?inviteCode={{user.id}} </span>
                    <div><a href=""></a></div>
                  </el-col>
                </el-row> -->
              </div>
            </el-tab-pane>
            <el-tab-pane name="charge" label="在线充值">
              <div class="wrap-box">
                <div class="space">当前余额：<span class="balance">{{ user.balance | balanceFilter }}</span>
                  <span style="margin-left:20px" @click="getSearchCount"><el-button type="primary" plain size="small">查询超值套餐包状态</el-button></span>
                  <div style="color:red;margin-top:10px;padding:16px;background-color:pink;font-size:13px">
                    <!-- <div style="font-size:16px;color:#000;font-weight:bold;margin-bottom:10px;">重要说明：</div> -->
                    <div>1、如果充值后长时间不到账，请尝试退出重新登录！！！</div>
                    <div style="margin-top:6px;line-height:1.5">2、点击余额旁的“查询超值套餐包状态”按钮，如果购买成功会提示超值套餐包信息，否则为未购买成功，请前往套餐购买处重新开通</div>
                  </div>
                </div>
                <el-row :gutter="40" class="space">
                  <el-col :span="12">
                    <div :class="{'item':true,'active':money==50}" @click="selectMoney(50)">
                      <img src="../assets/icons/charge.png" class="cover" alt="">
                      ￥50 元
                    </div>
                  </el-col>
                  <el-col :span="12">                  
                    <div :class="{'item':true,'active':money==500}" @click="selectMoney(500)">
                      <img src="../assets/icons/charge.png" class="cover" alt="">
                      ￥500 元
                    </div>                   
                  </el-col>                
                </el-row>
                <el-row :gutter="40" class="space">
                  <el-col :span="12">                  
                    <div :class="{'item':true,'active':money==1000}" @click="selectMoney(1000)">
                      <img src="../assets/icons/charge.png" class="cover" alt="">
                      ￥1000 元
                    </div>                   
                  </el-col>
                  <el-col :span="12">                  
                    <div :class="{'item':true,'active':money==5000}" @click="selectMoney(5000)">
                      <img src="../assets/icons/charge.png" class="cover" alt="">
                      ￥5000 元
                    </div>                   
                  </el-col>
                </el-row>
                <el-row class="space">
                  <el-col>
                    <el-divider content-position="left">充值金额(其他金额可手动输入)</el-divider>
                    <el-row :gutter="40">
                      <el-col :span="12">
                        <el-input type="number" step="10" placeholder="充值金额" v-model="money"></el-input>
                      </el-col>
                      <el-col :span="12">
                        <el-button type="primary" style="width:100%;" @click="charge">确定</el-button>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane name="singleton" label="薪酬查询包年">
              <div class="wrap-box">
                <div style="margin-bottom:20px">单城市单口径1000元，七个口径总价5000元</div>
                <el-row :gutter="40" class="space">
                  <el-col :span="24">
                    <span style="margin-right:20px;"><el-tag effect="dark" type="primary">地区: {{city}}</el-tag></span>
                    <span style="margin-right:20px;"><el-tag effect="dark" type="primary">行业: {{industry}}</el-tag></span>
                    <span style="margin-right:20px;"><el-tag effect="dark" type="primary">企业性质: {{property}}</el-tag></span>
                    
                    <el-divider content-position="right">选择城市</el-divider>
                    <span v-for="(item,index) in citys" :key="index" class="cityItem">
                      <el-dropdown>
                        <span class="el-dropdown-link">
                          {{item.name}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="selectCity(indus.name)" v-for="(indus,idx) in item.children" :key="idx">{{indus.name}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </span>
                    <el-divider content-position="right">选择行业</el-divider>
                    <span v-for="(item,index) in industrys" :key="'industry-'+index" class="cityItem">
                      <el-dropdown>
                        <span class="el-dropdown-link">
                          {{item.name}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="selectIndustry(indus.name)" v-for="(indus,idx) in item.children" :key="idx">{{indus.name}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </span>
                    <el-divider content-position="right">选择企业性质</el-divider>
                    <div style="margin-top: 20px">
                      <el-radio-group v-model="property" size="mini">
                        <el-radio-button label="民营"></el-radio-button>
                        <el-radio-button label="国有"></el-radio-button>
                        <el-radio-button label="合资"></el-radio-button>
                        <el-radio-button label="外资"></el-radio-button>
                        <el-radio-button label="全部"></el-radio-button>
                      </el-radio-group>
                    </div>
                    <el-divider content-position="right">选择统计口径（满五个免费赠送其余的两个）</el-divider>                    
                    <el-select @change="changeKoujing" style="width:100%;margin-bottom:30px;" v-model="koujing" multiple placeholder="请选择*多选">
                      <el-option label="月基本收入" value="月基本收入"></el-option>
                      <el-option label="月绩效收入" value="月绩效收入"></el-option>
                      <el-option label="月总收入" value="月总收入"></el-option>
                      <el-option label="年基本收入" value="年基本收入"></el-option>
                      <el-option label="年固定收入" value="年固定收入"></el-option>
                      <el-option label="年总收入" value="年总收入"></el-option>
                      <el-option label="年总成本" value="年总成本"></el-option>
                    </el-select>
                    <el-row>
                      <el-col :span="21">
                        需支付：{{ total }} 元
                      </el-col>
                      <el-col :span="3">
                        <el-button type="primary" @click="goBuyKoujing">确定</el-button>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>            
            <el-tab-pane name="package">
              <span slot="label">开通超值套餐包<span style="color:red;"><sup>火爆</sup></span></span>
              <div class="wrap-box">
                <el-row>
                  <el-col :span="24" style="text-align:center">
                    <h3 class="title">用户须知</h3>
                    <div class="subtitle">套餐价格:￥1000元<span style="color:red;padding-left:10px;text-decoration:line-through">原价值3000元</span></div>
                    <div class="subtitle">服务期限：<span style="color:red;">{{ getTimeRange }}</span>。<br/>服务内容：所有工具免费下载、100次薪酬查询、50次简版测评、任选三个培训课程观看权限。</div>
                    <el-divider content-position="left">选择三个培训课程</el-divider>
                    <div><el-select v-model="kecheng" multiple-limit="3" style="width:100%;margin-bottom:30px;" multiple placeholder="请选择">                      
                      <el-option value="1" label="DISC性格领导力"></el-option>
                      <el-option value="2" label="DISC在人才选用育留中的应用"></el-option>
                      <el-option value="3" label="HR核心工作法--CAD三角解决方案"></el-option>
                      <el-option value="4" label="传统HR变革进行时"></el-option>
                      <el-option value="5" label="非人力资源的人力资源管理"></el-option>
                      <el-option value="6" label="基于胜任力的人才发展规划"></el-option>
                      <el-option value="7" label="金盘面试官"></el-option>
                      <el-option value="8" label="人才炼金术：人才盘点"></el-option>
                      <el-option value="9" label="视频面试——为招聘工作开通快车道"></el-option>
                      <el-option value="10" label="新任经理人的核心角色转变"></el-option>
                      <el-option value="11" label="员工执行力塑造"></el-option>
                      <el-option value="12" label="组织诊断利器---员工满意度敬业度调研解析"></el-option>
                    </el-select>
                    </div>
                    <el-button type="primary" @click="upgradePackage">确认开通</el-button>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane name="vip" label="开通薪酬VIP">
              <div class="wrap-box">
                <el-row>
                  <el-col :span="24" style="text-align:center">
                    <h3 class="title">用户须知</h3>
                    <div class="subtitle">套餐价格:￥9800元</div>
                    <div class="subtitle">服务期限：<span style="color:red;">{{ getTimeRange }}</span>。<br/>服务内容：所有城市、行业、企业性质、所有统计口径的免费查询。</div>
                    <el-button type="primary" @click="upgradeVIP">确认开通</el-button>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane name="test_vip" label="开通测评VIP">
              <div class="wrap-box">
                <el-row>
                  <el-col :span="24" style="text-align:center">
                    <h3 class="title">用户须知</h3>
                    <div class="subtitle">套餐价格:￥10000元</div>
                    <div class="subtitle">服务期限：<span style="color:red;">{{ getTimeRange }}</span>。<br/>服务内容：disc,mbti,九型人格三种测评类型专业版报告全年测评。</div>
                    <el-button type="primary" @click="upgradeTestVIP">确认开通</el-button>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
            <!-- <el-tab-pane name="spread" label="推广奖励">
              <div class="wrap-box">
                <div class="space">推广奖励金：<span class="balance">￥{{spread.total}}元</span><el-button v-if="spread.total != 0" @click="applyCashOut" size="mini" style="margin-left:20px;">申请提现</el-button></div>
                <div style="color:#cccccc;font-size:12px;margin-bottom:20px;">每个月仅20号统一处理提现申请</div>
                <el-row :gutter="40" class="space">
                  <el-col :span="24">
                    <el-table
                      :data="spread.tree"
                      style="width: 100%;margin-bottom: 20px;"
                      row-key="id"
                      border
                      :default-expand-all="false"
                      :tree-props="{children: 'child', hasChildren: 'hasChildren'}">
                      <el-table-column
                        prop="user_email"
                        label="用户消费明细"
                        sortable
                        width="300">
                      </el-table-column>
                      <el-table-column
                        prop="consume_type_name"
                        label="消费项目"
                        sortable
                        width="180">
                      </el-table-column>
                      <el-table-column
                        prop="consume_price"
                        label="消费金额">
                      </el-table-column>
                    </el-table>
                  </el-col>            
                </el-row>                
              </div>
            </el-tab-pane> -->
          </el-tabs>   
        </el-col>  
      </el-row>     
    </div>
  </div>
</template>
<script>
import { fetchGet,fetchPost } from '../utils/http';
import citys from '../utils/citys';
import industrys from '../utils/industrys';
export default {
  name:'memberCenter',
  data(){
    return {
      source:"http://www.taizhicn.com",
      activeIndex:'userInfo',      
      loading:false,
      citys:citys,
      kecheng:[],
      industrys:industrys,
      tableData:[],
      spread:[],
      user:{
        id:'',
        user_email:'gfdhuishfsu',
        iscompanyhr:"企业HR",
        companyname:'',
        hangye:'',
        post:'',
        balance:5000,
      },
      money:1000,
      city:'待选择',
      industry:'待选择',
      property:'待选择',
      koujing:[],
      oldKoujing:[],
      total:0,
      arrayLists:['月基本收入','月绩效收入','月总收入','年基本收入','年固定收入','年总收入','年总成本']
    }
  },
  computed:{
    getTimeRange(){
      let d1 = new Date();
      let startTime = d1.toLocaleDateString();
      let d2 = new Date(); 
      d2.setFullYear(d2.getFullYear()+1); 
      d2.setDate(d2.getDate()-1); 
      let endTime = d2.toLocaleDateString();
      return startTime+'至'+endTime;
    },
  },
  methods:{
    getSearchCount(){
      let _this = this
      fetchGet('/api/home/api/getSearchCount')
      .then((res)=>{
        if( res.data.code === 1){
          _this.$notify({
            title:'温馨提示',
            message:res.data.msg,
            type:'success'
          });
        }
      });
    },
    upgradeVIP(){
      let _this = this;
      fetchGet('/api/home/api/upgradeVIP')
      .then((res)=>{
        if( res.data.code === 10002 ){
          _this.$notify({
            title:'提示',
            message:res.data.msg,
            type:'warning'
          });
          _this.activeIndex = 'charge';
        }
        if( res.data.code === 1){
          _this.$notify({
            title:'恭喜你',
            message:res.data.msg,
            type:'success'
          });
          _this.$router.push('/search');
        }
      });
    },
    upgradeTestVIP(){
      let _this = this;
      fetchGet('/api/home/api/upgradeTestVIP')
      .then((res)=>{
        if( res.data.code === 10002 ){
          _this.$notify({
            title:'提示',
            message:res.data.msg,
            type:'warning'
          });
          _this.activeIndex = 'charge';
        }
        if( res.data.code === 1){
          _this.$notify({
            title:'恭喜你',
            message:res.data.msg,
            type:'success'
          });
          _this.$router.push('/');
        }
      });
    },
    upgradePackage(){
      let _this = this;
      if(this.kecheng.length != 3){
        return this.$message.error('请选择三个课程');
      }
      fetchPost('/api/home/api/upgradePackage',{
        kecheng:this.kecheng
      })
      .then((res)=>{
        if( res.data.code === 10002 ){
          _this.$notify({
            title:'提示',
            message:res.data.msg,
            type:'warning'
          });
          _this.activeIndex = 'charge';
        }
        if( res.data.code === 1){
          // _this.$notify({
          //   title:'恭喜你',
          //   message:res.data.msg,
          //   type:'success'
          // });
          _this.$alert(res.data.msg, '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              _this.$router.push('/');
            }
          });          
        }
      });
    },
    selectMoney(value){
      //console.log(value);
      this.money = value;
    },
    selectCity(value){
      this.city = value;
    },
    selectIndustry(value){
      this.industry = value;
    },    
    changeKoujing(val){
      //console.log(val);
      if(this.oldKoujing.length < val.length){
        this.oldKoujing = val;
        let count = val.length;
        if( count >= 5 ){
          this.total = 5000;
          this.koujing = this.arrayLists;
        }else{
          this.total = this.koujing.length * 1000;
        }
      }
      
      if(this.oldKoujing.length > val.length){
        this.koujing = val;
        this.oldKoujing = val;
        this.total = this.koujing.length * 1000;
      }     
    },
    goBuyKoujing(){
      if(this.city == '待选择' || this.industry == '待选择' || this.property == '待选择' || this.koujing.length == 0 ){
        this.$notify({
          title:'提示',
          message:'请选择完整条件(城市、行业、企业性质,细分口径缺一不可)',
          type:'warning'
        });
        return;
      }
      let _this = this;
      fetchPost('/api/home/api/upgradeSingleBuyer',{
        city:this.city,
        industry:this.industry,
        property:this.property,
        koujing:this.koujing.join(',')
      }).then((res)=>{
        if(res.data.code === 10002){
          _this.$notify({
            title:'提示',
            message:res.data.msg,
            type:'warning'
          });
          return;
        }
        if(res.data.code === 1){
          _this.$notify({
            title:'恭喜你',
            message:res.data.msg,
            type:'success'
          });
          return;
        }
      });
    },
    submit(){
      let iscompanyhr = this.user.iscompanyhr;
      let hangye      = this.user.hangye;
      let companyname = this.user.companyname;
      let post        = this.user.post;
      if (iscompanyhr == null || hangye == null || companyname == null || post == null){
        this.$notify({
          title:'提示',
          message:'请填写完整信息',
          type:'warning'
        });
        return;
      }
      let _this = this;
      fetchPost('/api/home/api/userInfo',{
        iscompanyhr,
        hangye,
        companyname,
        post
      }).then((res)=>{
        //console.log(res.data);
        if( res.data.code === 1 ){
          _this.$message({
            message:res.data.msg,
            type:'success'
          });
          let oldUser = JSON.parse(sessionStorage.getItem('user'));
          let newUser = {...oldUser,..._this.user};
          sessionStorage.setItem('user',JSON.stringify(newUser));
        }
      })
    },
    charge(){
      if(this.money != '' && this.money%1 === 0 ){
        //提交充值信息
        fetchPost('/api/home/api/pay',{
          money:this.money, source: this.source
        }).then(res=>{
          //console.log(res.data);
          if( res.data.code === 1 ){
            const div = document.createElement('div')
            div.innerHTML = res.data.data.form;
            document.body.appendChild(div);
            document.forms[0].submit();
            return;
          }
          this.$message.error(res.data.msg)
        })
      }else{
        this.$message({
          message:'请选择或输入正确的充值金额',
          type:'warning'
        })
      }
    },
    applyCashOut(){
      fetchPost('/api/home/api/applyCashOut',{
        spread:this.spread
      }).then(res=>{
          if( res.data.code === 1 ){
            this.$message.success(res.data.msg)
            this.spread = res.data.data.spread;
            this.total = res.data.data.spread.total;
          }else{
            this.$message.error(res.data.msg)
          }
          
      })
    }
  },
  filters:{
    balanceFilter(value){
      return '￥' + value/100 + ' 元';
    }
  },
  mounted(){
    let activeIndex = this.$route.params.activeIndex;
    //console.log(activeIndex);
    if( activeIndex != undefined ){
      this.activeIndex = activeIndex;
    }
    
    let user = JSON.parse(sessionStorage.getItem('user'));    
    let spread = JSON.parse(sessionStorage.getItem('spread'));    
    this.user = user;
    this.spread = spread;    
  }
}
</script>
<style scoped>
.bg{
  margin: 80px 100px 40px 100px;  
  padding: 40px 0;
  background-color: #ffffff;
  border-radius: 10px;
}
#memberCenter{
  background-color: #f4f4f4;
}
.wrap-box{
  margin: 0 20px;

}
.space{
  margin-bottom: 24px;
}
.item{  
  position: relative;
  padding: 30px 40px;
  text-align: left;
  font-size: 18px;
  border-radius: 8px;
  border: 1px solid #70def7;
  cursor: pointer;
}
.cover{
  position: absolute;
  right:2px;
  top: 3px;
  height: 100%;
  transform:rotate(20deg);
}

.active{
  background: linear-gradient(to left top,#70def7,#0bc8f4);
  color: #ffffff;  
  font-weight: bold;
  box-shadow: 0 2px 15px #0bc8f4;
}
.balance{
  font-size: 24px;
  color: #0bc8f4;
  font-weight: bold;
}
.cityItem{
  margin-right: 10px;
  padding: 2px 5px;
  margin-bottom: 10px;
  display: inline-block;  
}
.el-dropdown-link {
  cursor: pointer;
  color: #939393;
}
.el-dropdown-link:hover{
  color: #0bc8f4!important;
}
.el-dropdown-menu__item{
  line-height: 24px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title{
  color: red;
  margin-bottom: 50px;
}
.subtitle{
  text-align: left;
  font-size: 18px;
  line-height: 30px;
  margin-bottom: 50px;  
}
</style>
